import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

export default function HorseDocuments({ status, documents = [] }) {
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  if (!['Bought', 'Sold'].includes(status) && documents.length === 0) return null;

  // Group docs by tag correctly
  const groupedDocs = documents.reduce((acc, doc) => {
    if (!acc[doc.tag]) acc[doc.tag] = [];
    acc[doc.tag].push(doc);
    return acc;
  }, {});

  // Only allow image extensions
  const isImage = (url) => /\.(jpe?g|png|webp)$/i.test(url);

  const handleImageClick = (group, index) => {
    const images = groupedDocs[group]
      .filter((doc) => isImage(doc.url))
      .map((doc) => doc.url);
    setLightboxImages(images);
    setLightboxIndex(index);
    setIsLightboxOpen(true);
  };

  return (
    <div className="mt-5 p-3 font-montserrat shadow">
      <h2 className="text-xl font-bold mb-2">Horse Documents</h2>

      {documents.length === 0 ? (
        <div className="bg-gray-100 p-4 rounded relative overflow-hidden">
          <div className="absolute inset-0 backdrop-blur-md bg-white/60 flex items-center justify-center z-10">
            <button className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700">
              Request Access
            </button>
          </div>
          <p className="text-gray-600 text-sm">Documents will appear here once access is granted.</p>
        </div>
      ) : (
        <>
          {['medical', 'show'].map((tag) =>
            groupedDocs[tag] ? (
              <div key={tag} className="mb-4">
                <h3 className="font-semibold text-text mb-2">
                  {tag === 'medical' ? 'Medical Records' : 'Show Records'}
                </h3>
                <div className="flex flex-wrap gap-4">
                  {groupedDocs[tag].map((doc, i) =>
                    isImage(doc.url) ? (
                      <img
                        key={i}
                        src={doc.url}
                        alt={`${tag} doc ${i + 1}`}
                        onClick={() => handleImageClick(tag, i)}
                        className="w-24 h-24 object-cover cursor-pointer border rounded"
                      />
                    ) : (
                      <a
                        key={i}
                        href={doc.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline text-sm"
                      >
                        View {tag} Document {i + 1}
                      </a>
                    )
                  )}
                </div>
              </div>
            ) : null
          )}
        </>
      )}

      {isLightboxOpen && lightboxImages.length > 0 && (
        <Lightbox
          mainSrc={lightboxImages[lightboxIndex]}
          nextSrc={lightboxImages[(lightboxIndex + 1) % lightboxImages.length]}
          prevSrc={lightboxImages[(lightboxIndex + lightboxImages.length - 1) % lightboxImages.length]}
          onCloseRequest={() => setIsLightboxOpen(false)}
          onMovePrevRequest={() =>
            setLightboxIndex((lightboxIndex + lightboxImages.length - 1) % lightboxImages.length)
          }
          onMoveNextRequest={() =>
            setLightboxIndex((lightboxIndex + 1) % lightboxImages.length)
          }
        />
      )}
    </div>
  );
}